import gridMixin from '../grid.mixin';
import fg from '#/libs/FrameGrid';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  assignDurations,
  CursorManager,
  getResizeAvailability,
  mapAvailability2Cursor,
} from '../../api/tapi';
import tmBus from '../../api/tmBus';

export default {
  mixins: [gridMixin],

  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      secondhand: (state) => state.secondhand,
      ...mapGetters('timemachine', ['getBgBeats']),
    }),

    bgBeatsTimes() {
      return this.getBgBeats.map((item) => item.time);
    },

    moveObj() {
      return {
        enabled: this.MODE_SCENE_EDIT,
        distance2trigger: this.CONST.DND_SENSITIVITY.RESIZE,
        onMoveStart: this.$_onMoveStart,
        onMove: this.$_onMove,
        onMoveEnd: this.$_onMoveEnd,
      };
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SELECT_OVERLAY',
    ]),

    $_onMoveStart(state) {
      this.SET_MODE({ name: 'OVERLAY_RESIZE', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });
      this.SELECT_OVERLAY({ overlay: this.$props.overlay });
      this.$emit('update:isOverlayResizing', true);

      state.mousePoint = this.$_mouse2point(state.eDown);
      state.initial = assignDurations({}, this.$props.overlay);

      const timeWindow = this.$props.pipa.getOverlayResizeTimeWindow(
        this.$props.overlay,
        { relativeToScene: false }
      );

      if (this.$props.fromLeft) {
        state.startTime = this.$props.pipa.toAbsolute(
          this.$props.overlay.displayStartTime
        );
        state.shiftX = this.$props.rectangle.p1.x - state.mousePoint.x;
        state.timeWindow = timeWindow.left;
      } else {
        state.startTime = this.$props.pipa.toAbsolute(
          this.$props.overlay.displayEndTime
        );
        state.shiftX = this.$props.rectangle.p2.x - state.mousePoint.x;
        state.timeWindow = timeWindow.right;
      }

      const aTimes = [
        state.timeWindow.min,
        state.timeWindow.max,
        ...this.bgBeatsTimes,
      ];
      if (
        _.between(state.timeWindow.min, this.secondhand, state.timeWindow.max)
      ) {
        aTimes.push(this.secondhand);
      }
      state.proximityTester = this.$_createProximityTester(
        aTimes,
        this.CONST.AUTOSNAP_PROXIMITY.RESIZE
      );

      tmBus.$emit('callbackOverlayResizeStart', {
        overlay: this.$props.overlay,
      });
    },

    $_onMove(state) {
      // constrain current time
      this.$_mouse2point(state.eMove, state.mousePoint, state.shiftX);
      let curTime = state.mousePoint.time;
      const snapTime = state.proximityTester.find(state.mousePoint.time);
      if (null !== snapTime) {
        curTime = snapTime;
      }
      state.curTime = _.constrain(
        state.timeWindow.min,
        curTime,
        state.timeWindow.max
      );

      if (this.$props.fromLeft) {
        this.$_moveFromLeft(state);
      } else {
        this.$_moveFromRight(state);
      }

      const resizeWindow = this.$props.pipa.getOverlayResizeTimeWindow(
        this.$props.overlay,
        { relativeToScene: true }
      );
      const availability = getResizeAvailability(
        resizeWindow,
        this.$props.overlay
      );
      const cursorMap = mapAvailability2Cursor(availability);
      CursorManager.set(
        this.$props.fromLeft ? cursorMap.left : cursorMap.right
      );

      tmBus.$emit('callbackOverlayResizeUpdate', {
        overlay: this.$props.overlay,
      });
      tmBus.$emit('callbackSceneUpdate', {
        e: state.eMove,
        scene: this.$props.pipa.scene,
        reflectUsage: false,
      });
    },

    $_moveFromLeft(state) {
      // constrain new duration
      const min = this.$props.overlay.limit.min;
      let max = this.$props.overlay.limit.max;
      if (this.$props.overlay.limit.fragment) {
        max = fg.trunc(
          this.$props.overlay.endTime - this.$props.overlay.limit.fragment.min
        );
      }
      let newDuration =
        this.$props.overlay.displayEndTime -
        (state.curTime - this.$props.pipa.scene.displayStartTime);
      newDuration = _.constrain(min, newDuration, max);

      this.$props.overlay.displayStartTime = fg.trunc(
        this.$props.overlay.displayEndTime - newDuration
      );
      this.$props.overlay.displayDuration = fg.trunc(
        this.$props.overlay.displayEndTime -
          this.$props.overlay.displayStartTime
      );

      if (this.$props.overlay.limit.fragment) {
        this.$props.overlay.startTime = fg.trunc(
          this.$props.overlay.endTime - newDuration
        );
      }
    },

    $_moveFromRight(state) {
      // constrain new duration
      const min = this.$props.overlay.limit.min;
      let max = this.$props.overlay.limit.max;
      if (this.$props.overlay.limit.fragment) {
        max = fg.trunc(
          this.$props.overlay.limit.fragment.max - this.$props.overlay.startTime
        );
      }
      let newDuration =
        state.curTime -
        (this.$props.pipa.scene.displayStartTime +
          this.$props.overlay.displayStartTime);
      newDuration = _.constrain(min, newDuration, max);

      this.$props.overlay.displayEndTime = fg.trunc(
        this.$props.overlay.displayStartTime + newDuration
      );
      this.$props.overlay.displayDuration = fg.trunc(
        this.$props.overlay.displayEndTime -
          this.$props.overlay.displayStartTime
      );

      if (this.$props.overlay.limit.fragment) {
        this.$props.overlay.endTime = fg.trunc(
          this.$props.overlay.startTime + newDuration
        );
      }
    },

    $_onMoveEnd(state) {
      CursorManager.restore();

      if (state.canceled) {
        assignDurations(this.$props.overlay, state.initial);
      }

      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'OVERLAY_RESIZE', value: false });
      this.$emit('update:isOverlayResizing', false);

      tmBus.$emit('callbackOverlayResizeStop', {
        overlay: this.$props.overlay,
      });
    },
  },
};
